var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.threadReceivers)?_c('PayersFilterDropdown',{ref:"dropdown",staticClass:"receivers",attrs:{"payer-ids":_vm.payerIds},on:{"selected":_vm.updatePayers}}):_c('PayersPredefinedDropdown',{staticClass:"response-receivers",attrs:{"init-open":"","payers":_vm.threadReceivers,"payer-ids":_vm.payerIds},on:{"selected":_vm.updatePayers}})
}
var staticRenderFns = []

export { render, staticRenderFns }